import React from 'react';
import { useFormWatch } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import CancelCreate from '../../controllers/CancelCreate';
import SaveNewConfig from '../../controllers/SaveNewConfig';
import AcceptanceNameAndPeriod from '../../../../presenters/AcceptanceNameAndPeriod';
import styles from './index.module.scss';

const Header = () => {
  const [fromDate, toDate] = useFormWatch({
    name: [fieldNames.main.fromDate, fieldNames.main.toDate],
  });

  return (
    <>
      <AcceptanceNameAndPeriod fromDate={fromDate} toDate={toDate} />
      <div className={styles.col}>
        <CancelCreate />
        <SaveNewConfig />
      </div>
    </>
  );
};

export default Header;
